const reasons = [
  {
    img: 'https://playdash.me/assets/images/6704096.webp',
    title: 'More Professional',
    desc: 'A polished, dependable platform — clear rules, stable performance, and support that answers in plain English. PNGGO is run like a real brand you can hold accountable, not a fly-by-night popup.',
  },
  {
    img: 'https://playdash.me/assets/images/8068026.webp',
    title: 'Safer',
    desc: 'Your account and your Kina are protected with strong encryption, secure sign-in practices, and careful handling of every transaction. Play with confidence knowing security is built in, not bolted on.',
  },
  {
    img: 'https://playdash.me/assets/images/9571530.webp',
    title: 'More Convenient',
    desc: 'Use PNGGO wherever you already are — phone on mobile data, tablet at home, or desktop when you want a bigger screen. One account, the same smooth experience across web and app.',
  },
  {
    img: 'https://playdash.me/assets/images/5487609.webp',
    title: 'Faster',
    desc: 'Deposits and withdrawals tuned for real-world use in Papua New Guinea: straightforward steps, predictable processing, and less waiting when you want your PGK back in your pocket.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="bg-[#0d0d0d] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-start gap-12">
          {/* Left */}
          <div className="lg:w-80 flex-shrink-0">
            <p className="text-[#B80E28] text-xs font-semibold tracking-widest uppercase mb-2">BUILT FOR PNG</p>
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">
              Why Players Choose PNGGO
            </h2>
            <p className="text-white/55 text-sm leading-6 mb-6 max-w-sm">
              Local-friendly money movement, a product that respects PNG players, and support that treats you like neighbours — not ticket numbers.
            </p>
            <a
              href="https://pnggo.bet/RFLANDINGPAGEPNG"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#B80E28] text-white font-semibold px-7 py-3 rounded-full hover:bg-[#9a0b21] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              JOIN NOW <i className="fas fa-chevron-right text-xs"></i>
            </a>
          </div>

          {/* Right grid */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {reasons.map((r, i) => (
              <div
                key={i}
                className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5 hover:border-[#B80E28]/30 transition-all duration-300 group"
              >
                <div className="w-14 h-14 flex items-center justify-center mb-4">
                  <img src={r.img} alt={r.title} className="w-12 h-12 object-contain group-hover:scale-110 transition-transform duration-300" />
                </div>
                <h3 className="text-[#B80E28] font-bold text-base mb-3">{r.title}</h3>
                <p className="text-white/55 text-sm leading-6 mb-4">{r.desc}</p>
                <a
                  href="https://pnggo.bet/RFLANDINGPAGEPNG"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#B80E28] text-sm font-medium hover:underline flex items-center gap-1 cursor-pointer"
                >
                  Learn More <i className="fas fa-chevron-right text-xs"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
